module.exports = __webpack_public_path__ + "assets/img/header_logo_white.87c38ceb.png";